export const iconFontAwesomeMedicalHealthJoint = (
	<i className="fa-solid fa-joint"></i>
);
